<template>
  <div>
    <el-dialog
      title="记录推送"
      :visible="dialogVisible"
      width="600px"
      :before-close="handleClose"
    >
      <div class="rule-item1">说明：系统自动将当前择校数据记录到择校记录中</div>
      <div class="rule-item2">
        备注说明：
        <el-input
          type="textarea"
          :autosize="{ minRows: 6, maxRows: 10 }"
          placeholder="请输入内容"
          style="width: 480px; margin-left: 10px"
          v-model="textarea"
        >
        </el-input>
      </div>
      <div class="btn-item">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="saveData">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { postRecommendRecord } from "@/api/apply";
export default {
  props: {},
  created() {},
  data() {
    return {
      dialogVisible: false,
      textarea: "",
      uuid: "",
      record_id: "",
    };
  },
  methods: {
    handleClose() {
      this.dialogVisible = false;
    },
    show(uuid, record_id) {
      this.dialogVisible = true;
      this.uuid = uuid;
      this.record_id = record_id;
    },
    saveData() {
      let data = {
        record_id: this.record_id,
        student_id: this.uuid,
        remarks: this.textarea,
      };
      postRecommendRecord(data).then(() => {
        this.$notify({
          title: "成功",
          message: "推送成功",
          type: "success",
        });
        this.textarea = ''
        this.$parent.record_id = null
        this.dialogVisible = false;
      });
    },
  },
};
</script>
<style lang="less" scoped>
.rule-item1 {
  margin-top: 10px;
}
.rule-item2 {
  margin-top: 20px;
  display: flex;
}
.btn-item {
  display: flex;
  justify-content: flex-end;
  margin-top: 30px;
}
.el-table {
  width: 1120px;
  margin-left: 10px;
  margin-top: 20px;
}
/deep/ .el-dialog__body {
  padding: 0 20px !important;
  padding-bottom: 20px !important;
}
</style>
